__turbopack_context__.v({
  "className": "dm_serif_display_d5f534fa-module__LimlBq__className",
});
